/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lots_Filter_GradeInputs */

const vi_sl_lots_filter_grade = /** @type {(inputs: Sl_Lots_Filter_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân loại`)
};

/**

* @param {Sl_Lots_Filter_GradeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lots_filter_grade = /** @type {((inputs?: Sl_Lots_Filter_GradeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lots_Filter_GradeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lots_filter_grade(inputs)
});